import React, { useState } from 'react'

function CleanDatabase() {
  const [checkbox] = useState([
    {
      id: "User",
      name: "User Section",
      value: "User"
    },
    {
      id: "Register",
      name: "Register",
      value: "Register"
    },
    {
      id: "Expence",
      name: "Expence",
      value: "Expence",
      for: ""
    },
    {
      id: "Customer",
      name: "Customer",
      value: "Customer",
      for: ""
    },
    {
      id: "Promotion",
      name: "Promotion",
      value: "Promotion"
      
    },
    {
      id: "Notifications",
      name: "Notifications",
      value: "Notifications",
      for: ""
    },
    {
      id: "Web Orders",
      name: "Web Orders",
      value: "Web Orders",
      for: ""
    },
    {
      id: "Deposit",
      name: "Deposit",
      value: "Deposit",
      for: ""
    },
    {
      id: "Returns",
      name: "Returns",
      value: "Returns",
      for: ""
    },
    {
      id: "Sales Items",
      name: "Sales Items",
      value: "Sales Items",
      for: ""
    },
    {
      id: "Food Menu Category",
      name: "Food Menu Category",
      value: "Food Menu Category",
      for: ""
    },
    {
      id: "Food Menu Items",
      name: "Food Menu Items",
      value: "Food Menu Items",
      for: ""
    },
    {
      id: "Purchases Items",
      name: "Purchases Items",
      value: "Purchases Items",
      for: ""
    },
    {
      id: "Add Ons",
      name: "Add Ons",
      value: "Add Ons",
      for: ""
    },
    {
      id: "Tables",
      name: "Tables",
      value: "Tables",
      for: ""
    },
    {
      id: "Ingredient Category",
      name: "Ingredient Category",
      value: "Ingredient Category",
      for: ""
    },
    {
      id: "Ingredients",
      name: "Ingredients",
      value: "Ingredients",
      for: ""
    },
    {
      id: "Units",
      name: "Units",
      value: "Units",
      for: ""
    },
    {
      id: "Subscription",
      name: "Subscription",
      value: "Subscription",
      for: ""
    },
    {
      id: "Hold Items",
      name: "Hold Items",
      value: "Hold Items",
      for: ""
    },
  ])
  return (
    <main>
      <div>
        <h1 className="text-[#7B20C7] text-2xl font-semibold py-5">Clean Database</h1>
      </div>

      
<div className='flex flex-wrap  lg:flex-row gap-x-8 gap-y-4 w-full'>

      {checkbox &&
        checkbox.map((element) => (
          
          <div className="form-check w-full lg:w-1/5">
            <input className="form-check-input " type="checkbox" value={element.value} id={element.id} required />
            <label className="form-check-label pl-2 font-bold text-[#7B20C7] " for={element.for}>
              {element.name} 
            </label>
          </div>
        ))}

        </div>
        <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2 pb-3">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              </div>
    </main>
  )
}

export default CleanDatabase
